<template>
    <div class="content content--registration content--no-progress">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky form-wrap__title--no-progress" v-if="!completePhone && !phoneApprove">Чтобы продолжить, укажите свой мобильный номер</h1>
                <h1 class="form-wrap__title form-wrap__title--sticky form-wrap__title--no-progress" v-if="completePhone || phoneApprove">Регистрация</h1>
                <div class="form-wrap__row">
                    <c-input-submit
                            :label="$t('login.phone')"
                            :fieldName="'phone'"
                            :type="'tel'"
                            v-model="phone"
                            :mask="'+7(###)###-##-##'"
                            :validation="'required|min:16'"

                            :externalStatus="phoneExternalStatus"
                            :sendFunction="checkPhone"
                            v-on:click.native="disabledTooltips"
                    >
                        <template slot="tooltip">
                            <c-tooltip v-show="phoneExternalError.haveError" :position="'left-bottom'" :top="115" :left="10">Возможно, вы регистрировались ранее, используя этот номер телефона</c-tooltip>

                            <c-tooltip v-if="isDesktop" v-show="showPhoneTooltip" :position="'right'" :top="15" :maxWidth="190" :left="370">Проверьте, правильно ли вы указали мобильный телефон.
                                Нажмите на поле, чтобы отредактировать</c-tooltip>
                            <c-tooltip v-if="!isDesktop" v-show="showPhoneTooltip" :position="'left'" :top="15" :left="0" :maxWidth="170">Проверьте, правильно ли вы указали мобильный телефон.
                                Нажмите на поле, чтобы отредактировать</c-tooltip>
                        </template>
                    </c-input-submit>
                </div>
                <transition name="fade" v-if="completePhone">
                    <div class="form-wrap__row">
                        <p class="form-wrap__row-title">Подтверждение <br> мобильного телефона</p>
                        <c-input-sms-code
                                :type="'tel'"
                                :fieldName="'smsCode'"
                                :mask="'# # # #'"
                                :label="'Код из СМС'"
                                v-model="smsCode"

                                :externalStatus="smsCodeExternalStatus"
                                :sendFunction="sendSmsCode"
                        >

                        </c-input-sms-code>

                        <div class="form-wrap__sms-timer">
                            <span class="form-wrap__timer-text" v-if="showTimer">Отправить код повторно</span>
                            <span class="form-wrap__timer-cloak" v-if="showTimer">{{timerText}}</span>
                            <span class="form-wrap__timer-link" v-on:click="repeatTimer" v-if="!showTimer">Отправить код повторно</span>
                        </div>
                    </div>
                </transition>
                <transition name="fade" v-if="phoneApprove">
                    <template >
                        <div class="form-wrap__row">
                            <c-input-submit
                                    :label="'Email'"
                                    :fieldName="'email'"
                                    :type="'email'"
                                    v-model="email"
                                    :validation="'required|email'"

                                    :externalStatus="emailExternalStatus"
                                    :sendFunction="checkEmail"
                                    v-on:click.native="disabledTooltips"
                            >
                                <c-tooltip v-show="emailExternalError.haveError" :position="'left-bottom'" :top="115" :left="10">Возможно, вы регистрировались ранее, используя этот email</c-tooltip>
                            </c-input-submit>
                        </div>
                    </template>
                </transition>
                <template v-if="emailComplete">
                        <div class="form-wrap__row">
                            <c-input-password
                                    :label="'Создайте пароль'"
                                    :type="'password'"
                                    :fieldName="'password'"
                                    v-model="password"

                                    ref="password"
                            >
                                <template slot="hint">
                                    Пароль должен содержать не менее 8 символов
                                </template>
                            </c-input-password>
                        </div>

                        <div class="form-wrap__row" v-if="showRepeatPassword">
                            <c-input-submit
                                    :label="'Повторите пароль'"
                                    :fieldName="'passwordRepeat'"
                                    :type="'password'"
                                    v-model="passwordRepeat"
                                    :validation="'required|min:8'"

                                    :externalStatus="passwordExternalStatus"
                                    :sendFunction="confirmRegistrations"
                                    v-on:click.native="disabledTooltips"
                            >
                                <template slot="hint">
                                    <span v-show="passwordConfirm" class="text--blue">Пароли совпадают</span>
                                </template>
                            </c-input-submit>
                        </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
    import {STATUSES} from "@/components/statuses";
    import {TOGGLE_LOADER} from "@/storage/mutations";
    import widthMixin from "@/modules/mixins/widthMixin";

    const TIMER = 60;
    export default {
        name: 'Registration',
        mixins: [widthMixin],
        metaInfo: {
          title: 'Регистрация'
        },
        data(){
            return {
                serverMessage: '',
                phone: '',
                email: '',
                smsCode: '',
                password: '',
                passwordRepeat: '',

                phoneExternalStatus: STATUSES.EMPTY,
                phoneExternalError:{
                    haveError: false,
                    errorText: ''
                },

                emailExternalStatus: STATUSES.EMPTY,
                emailExternalError:{
                    haveError: false,
                    errorText: ''
                },

                smsCodeExternalStatus: STATUSES.EMPTY,
                smsCodeExternalError:{
                    haveError: false,
                    errorText: ''
                },

                passwordExternalStatus: STATUSES.EMPTY,
                passwordExternalError:{
                    haveError: false,
                    errorText: ''
                },



                showTimer: true,
                timer: TIMER,
                timerObject: '',
                timerText : 'Через '+TIMER+' сек',
                showPhoneTooltip: false,



            }
        },
        watch: {
          phone: function (oldVal, newVal) {
              if( oldVal !== newVal){
                  this.phoneExternalError.haveError = false;
                  this.phoneExternalStatus = STATUSES.EMPTY;
                  this.showPhoneTooltip = false;

                  clearInterval(this.timerObject);
                  this.timer = TIMER;
                  this.showTimer = true;
              }
          },
          email: function(oldVal, newVal){
              if( oldVal !== newVal){
                  this.emailExternalError.haveError = false;
                  this.emailExternalStatus = STATUSES.EMPTY;
              }
          },
          timer: function (oldVal, newVal) {
              this.timerText = 'Через '+newVal+' сек';
              if (newVal === 10 ){
                  this.showPhoneTooltip = true;
              }

              if(newVal === 0){
                  this.timer = TIMER;
                  this.showTimer = false;
                  clearInterval(this.timerObject);
              }

          },
           passwordRepeat: function (oldVal, newVal) {
              if( this.passwordConfirm ){
                  this.passwordExternalError.haveError = false;
                  this.passwordExternalError.errorText = '';
              }else{
                  this.passwordExternalError.haveError = true;
                  this.passwordExternalError.errorText = 'Пароли не совпадают';
              }
           },
        },
        methods: {
            disabledTooltips: function(){
                this.showPhoneTooltip = false;
            },
            checkPhone: function () {
                let _this = this;
                let data = new FormData();
                data.append('phone', this.clearPhone);
                data.append('email', '');
                this.phoneExternalStatus = STATUSES.LOAD;
                let animationTime = performance.now();
                this.$http.post("/v1/open/checkPhoneAndEMail", data).then(
                    response => {
                        let timeoutTime = (performance.now() - animationTime) >= 3000 ? 0 : 3000;
                        // Таймаут анимации для
                        setTimeout(_ => {
                            if (response.status === 200) {
                                this.phoneExternalStatus = STATUSES.LOAD_END;
                                    switch ( response.data.code){
                                        case 0: {
                                            // Таймаут для того что бы кончилась анимация с галочкой
                                            setTimeout( _ => {
                                                _this.phoneExternalStatus = STATUSES.COMPLETE;

                                                _this.timerObject = setInterval(_ => {
                                                    _this.timer -= 1;
                                                }, 1000)

                                            }, 1000);
                                            break;
                                        }
                                        case 1: {
                                            _this.$validator.errors.add(
                                                'phone',
                                                'Клиент с данным номером телефона уже зарегистрирован на сайте'
                                            );
                                            _this.phoneExternalStatus = STATUSES.EMPTY;
                                            break;
                                        }
                                        case 4: {
                                            // TODO smsSendingError - Показать ошибку отправки смс с сервера
                                            break;
                                        }
                                    }
                            }else{

                            }
                        }, timeoutTime);
                    },
                    response => {
                        _this.$store.commit(TOGGLE_LOADER, {state: false});
                    }
                );
            },
            checkEmail: function () {
                let _this = this;
                let data = new FormData();
                data.append('phone', this.clearPhone);
                data.append('email', this.email);
                this.emailExternalStatus = STATUSES.LOAD;
                let animationTime = performance.now();
                this.$http.post("/v1/open/checkPhoneAndEMailSmsNotSent", data).then(
                    response => {
                        let timeoutTime = (performance.now() - animationTime) >= 3000 ? 0 : 3000;
                        // Таймаут анимации для
                        setTimeout(_ => {
                            if (response.status === 200) {
                                this.emailExternalStatus = STATUSES.LOAD_END;
                                switch ( response.data.code){
                                    case 0: {
                                        // Таймаут для того что бы кончилась анимация с галочкой
                                        setTimeout( _ => {
                                            _this.emailExternalStatus = STATUSES.COMPLETE;
                                        }, 1000);
                                        break;
                                    }
                                    case 2: {
                                        _this.$validator.errors.add(
                                            'email',
                                            'Клиент с данным email\'ом уже зарегистрирован на сайте'
                                        );
                                        _this.emailExternalStatus = STATUSES.EMPTY;
                                        break;
                                    }
                                    case 4: {
                                        // TODO smsSendingError - Показать ошибку отправки смс с сервера
                                        break;
                                    }
                                }
                            }else{

                            }
                        }, timeoutTime);
                    },
                    response => {
                        _this.$store.commit(TOGGLE_LOADER, {state: false});
                    }
                );
            },
            sendSmsCode: function () {
                let _this = this;
                clearInterval(this.timerObject);

                this.$http.get('/v1/open/checkSmsCode?code='+this.clearSmsCode).then(
                    response => {
                        _this.serverMessage = JSON.stringify(response.data);
                        _this.smsCodeExternalStatus = STATUSES.LOAD;

                        if(response.data.code === 0){
                                _this.smsCodeExternalStatus = STATUSES.COMPLETE;
                                _this.phoneExternalStatus = STATUSES.APPROVE;
                                _this.smsCodeExternalError.haveError = false;

                                clearInterval(this.timerObject);
                                _this.timer = TIMER;
                                _this.showPhoneTooltip = false;

                        }else{
                            _this.smsCodeExternalStatus = STATUSES.EMPTY;
                            _this.smsCodeExternalError.haveError = true;
                            _this.smsCodeExternalError.errorText = 'Неверный код';
                        }
                    },
                    response => {
                        _this.serverMessage = JSON.stringify(response.data);
                        _this.smsCodeExternalStatus = STATUSES.EMPTY;
                        _this.smsCodeExternalError.haveError = true;
                        _this.smsCodeExternalError.errorText = 'Неверный код';
                    }
                );
            },
            confirmRegistrations(){
                let _this = this;
                let data = new FormData();
                data.append('phone', this.clearPhone);
                data.append('email', this.email);
                data.append('password', this.password);
                data.append('smscode', this.clearSmsCode);
                _this.$store.commit(TOGGLE_LOADER, {state: true});
                this.$http.post('/v1/open/registration', data).then(
                    response => {
                        switch( response.data.code){
                            case 0: {
                                // Временное решение, переписать при первой же возможности
                                let loginDate = new URLSearchParams();
                                loginDate.append('username', _this.clearPhone);
                                loginDate.append('password', _this.password);
                                _this.$http.post("/json/login", loginDate).then(
                                    response => {
                                        if (response.status === 200) {
                                            _this.$router.push({name: 'RegistrationThanks'});
                                        }
                                    },
                                    response => {
                                        // TODO: Залогировать ошибку логина.
                                    }
                                );


                                break;
                            }
                            default: {
                                _this.$store.commit(TOGGLE_LOADER, {state: false});

                            }
                            //TODO: Дописать обработку все остальных случаев регистрации
                        }

                    },
                    response => {

                    }
                );
            },
            repeatTimer: function () {
                this.timerText = 'Через '+this.timer+' сек';
                this.showTimer = true;
                this.timerObject = setInterval(_ => {
                    this.timer -= 1;
                }, 1000);
            },
        },
        computed: {
            completePhone: function(){
               return this.phoneExternalStatus === STATUSES.COMPLETE;
            },
            phoneApprove: function(){
               return this.phoneExternalStatus === STATUSES.APPROVE;
            },
            emailComplete: function(){
               return this.emailExternalStatus === STATUSES.COMPLETE;
            },
            passwordConfirm: function () {
                return  (this.password.length >= 8) && (this.password === this.passwordRepeat);
            },
            showRepeatPassword: function(){
              return this.password.length >= 8;
            },
            clearPhone: function(){
                return this.phone.replace(/[^0-9.]/g, "");
            },
            clearSmsCode: function () {
                return this.smsCode.replace(/[^0-9.]/g, "");
            }
        }
    }
</script>

<style lang="scss">
    .content{
        &.content--no-progress{
            padding-top: 75px;
        }
        &.content--small-progress{
            padding-top: 45px;
        }
    }
    .form-wrap__title.form-wrap__title--sticky.form-wrap__title--no-progress{
        top: 45px;
    }
</style>